export default __webpack_public_path__ + "static/media/map-feature.57750699.svg";